export const SELECT_MODEL_FACTOR = 'SELECT_MODEL_FACTOR'

export const selectModelFactor = (modelFactorID) => ({
  type: SELECT_MODEL_FACTOR,
  payload: modelFactorID,
})

export const IHEALTHY_ULTRA_UPDATE_SELECTED_BASIC_PLAN = 'IHEALTHY_ULTRA_UPDATE_SELECTED_BASIC_PLAN'
export const updateSelectedBasicPlan = (basicPlanCode) => ({
  type: IHEALTHY_ULTRA_UPDATE_SELECTED_BASIC_PLAN,
  payload: basicPlanCode,
})

export const IHEALTHY_ULTRA_SELECT_BASIC_PLAN = 'IHEALTHY_ULTRA_SELECT_BASIC_PLAN'
export const selectBasicPlan = (product) => ({
  type: IHEALTHY_ULTRA_SELECT_BASIC_PLAN,
  payload: product,
})

export const VALIDATE_BASIC_PLAN = 'VALIDATE_BASIC_PLAN'
export const validateBasicPlan = () => ({ type: VALIDATE_BASIC_PLAN })

export const UPDATE_MHP_RIDER_MULTI_PLANCODE = 'UPDATE_MHP_RIDER_MULTI_PLANCODE'
export const updateMHPRiderMultiPlanCode = (riderPlanCode) => ({
  type: UPDATE_MHP_RIDER_MULTI_PLANCODE,
  payload: riderPlanCode,
})
